import { TabConfig } from 'components/shared/navigation/RoutedTabPanel/RoutedTabPanel.types';
import { makePath } from 'utils/navigation/makePath';

export const pathResolver = (pathname: string, tabs: TabConfig[]) => {
  const routes = tabs
    .map((singleTab) => {
      return makePath(singleTab.route, singleTab.routeParams);
    })
    .reverse();

  const exactPath = routes.find((route) => pathname === route);

  if (exactPath) {
    return exactPath;
  }

  const partialPath = routes.find((route) => pathname.startsWith(route));

  if (partialPath) {
    return partialPath;
  }

  return null;
};
